function handleCategoryChange(event, clickedElement, dropDownBtn) {
  const prevActiveEle = clickedElement.parentElement.querySelector('.is-selected');
  const viewMoreBtn = document.getElementById('view-more-btn');
  const span = dropDownBtn.firstChild;
  const headerHeight = 120;
  if (event.target.parentElement.classList.contains('desktop-only')
    || event.target.parentElement.parentElement.classList.contains('desktop-only')) {
    const element = document.querySelector('#integration-list-wrapper');
    const topOffset = element.getBoundingClientRect().top + window.pageYOffset - headerHeight;
    window.scrollTo({ top: topOffset, behavior: 'smooth' });
  }
  if (prevActiveEle === clickedElement) {
    return;
  }
  prevActiveEle.classList.remove('is-selected');
  clickedElement.classList.add('is-selected');
  dropDownBtn.parentElement.classList.remove('is-open');
  span.textContent = clickedElement.textContent;
  const {
    dataset: { categoryId },
  } = clickedElement;
  [...document.querySelector('.integration-card-list').children].forEach((card) => {
    if (card.classList.contains(categoryId)) {
      card.classList.remove('d-none');
    } else {
      card.classList.add('d-none');
    }
  });

  if (clickedElement.classList.contains('has-more')) viewMoreBtn.parentElement.classList.remove('d-none');
  else viewMoreBtn.parentElement.classList.add('d-none');
  viewMoreBtn.setAttribute('data-category-id', categoryId);
}

(function attachIntegrationCardActions() {
  const dropDownButton = document.getElementById('integration-dropdown');
  const cards = [...document.querySelector('.integration-card-list').children];
  const viewMoreBtn = document.getElementById('view-more-btn');

  dropDownButton.addEventListener('click', () => {
    dropDownButton.parentElement.classList.toggle('is-open');
  });

  document.querySelectorAll('.list-item').forEach((element) => {
    element.addEventListener('click', (event) => {
      event.stopPropagation();
      const listElement = event.target.nodeName !== 'LI' ? element.closest('.list-item') : element;
      handleCategoryChange(event, listElement, dropDownButton);
    });
  });

  viewMoreBtn.onclick = () => {
    const { categoryId } = viewMoreBtn.dataset;
    cards.forEach((card) => {
      if (card.classList.contains(`more-${categoryId}`)) {
        card.classList.remove('d-none');
      }
    });
    viewMoreBtn.parentElement.classList.add('d-none');
  };
}());
